import { PermissionCheck } from "app/features/permission/atoms/PermissionCheck";
import { PermissionsEnums } from "app/services/api/types/authorisation/enums/PermissionsEnums";
import { StatusFlagModel } from "app/services/api/types/statusFlags/models/StatusFlagModel";
import { View } from "ui/atoms/view";
import { Button, ButtonIcon } from "ui/gluestack/button";
import { EditIcon, TrashIcon } from "ui/gluestack/icon";

interface Props {
  flag: StatusFlagModel;
  onEdit?: (flag: StatusFlagModel) => void;
  onDelete?: (flag: StatusFlagModel) => void;
}

export default function StatusFlagActionButtons({
  flag,
  onEdit,
  onDelete,
}: Props) {
  return (
    <View className="flex-row gap-2 sm:self-center">
      {onEdit ? (
        <PermissionCheck permission={PermissionsEnums.UPDATE_STATUS_FLAG}>
          <Button
            size="xs"
            variant="link"
            onPress={() => onEdit(flag)}
            className="w-11 h-11 bg-gray-50"
          >
            <ButtonIcon as={EditIcon} />
          </Button>
        </PermissionCheck>
      ) : null}
      {onDelete ? (
        <PermissionCheck permission={PermissionsEnums.DELETE_STATUS_FLAG}>
          <Button
            size="xs"
            action="negative"
            variant="link"
            onPress={() => onDelete(flag)}
            className="w-11 h-11 bg-gray-50"
          >
            <ButtonIcon as={TrashIcon} />
          </Button>
        </PermissionCheck>
      ) : null}
    </View>
  );
}
